import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=de748a30&"
import script from "./NotificationCenter.vue?vue&type=script&lang=js&"
export * from "./NotificationCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports